import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TimeStamp from "react-timestamp";
import * as reactDeviceDetect from "react-device-detect";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
// Icons
import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";
import notificationStatus from "../../assets/img/notificationStatus.png";
import authorizeIMG from "../../assets/img/Authorize.png";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    PopupHeader: "Payment Declined",
    PopupText1: "Hello ",
    PopupText2:
      "We are having trouble authorizing your payment for your Intelligent Access Management System on ",
    PopupText3:
      "Please verify or update your payment method to avoid losing your subscription. If your payment information is correct, please contact your bank for more details.",
    PopupText4: "Reasons for failure may include the following:",
    PopupText5: "We will be attempting your payment again in a few days.",
    PopupText6_1:
      "If you have any questions or need assistance regarding the renewal process, please contact us at ",
    PopupText6_2: "support@egeetouch.com",
    PopupText6_3: ".",
    PopupTextBullet1: "Insufficient funds on the account",
    PopupTextBullet2: "Expired credit card",
    PopupTextBullet3: "Bank's fraudulence prevention policies",
    PopupButton: "Update details",
  },
  ja: {
    PopupHeader: "支払いが行われませんでした",
    PopupText1: "Hello ",
    PopupText2:
      "We are having trouble authorizing your payment for your Intelligent Access Management System on ",
    PopupText2_1:
      "にインテリジェントアクセス管理システムのお支払いを確認できませんでした。",
    PopupText2_2: "",
    PopupText2_3: "",
    PopupText3:
      "現在ご契約のプランが失効しないように、お支払い方法を確認または更新してください。お支払い情報が正しい場合は、カード会社もしくはお取引のある銀行に詳細をお問い合わせください。",
    PopupText4: "お支払不履行の理由には、次のものがあります。",
    PopupText5: "弊社ではお客様のお支払にを数日後に再度行います。",
    PopupText6_1:
      "この件に関してご質問がある場合、またはサポートが必要な場合は、",
    PopupText6_2: "support@egeetouch.com",
    PopupText6_3: "までご連絡ください。",
    PopupTextBullet1: "残高不足",
    PopupTextBullet2: "クレジットカードの期限切",
    PopupTextBullet3: "銀行の不正防止ポリシー",
    PopupButton: "更新",
  },
  es: {
    PopupHeader: "Pago Rechazado",
    PopupText1: "Hola ",
    PopupText2:
      "Estamos teniendo problemas para autorizar tu pago por tu Sistema de Gestión de Acceso Inteligente el ",
    PopupText3:
      "Por favor verifica o actualiza tu método de pago para evitar perder tu suscripción. Si tu información de pago es correcta, por favor contacta a tu banco para más detalles.",
    PopupText4: "Las razones de la falla pueden incluir lo siguiente:",
    PopupText5: "Intentaremos procesar tu pago nuevamente en unos días.",
    PopupText6_1:
      "Si tienes alguna pregunta o necesitas asistencia con respecto al proceso de renovación, por favor contáctanos en ",
    PopupText6_2: "support@egeetouch.com",
    PopupText6_3: ".",
    PopupTextBullet1: "Fondos insuficientes en la cuenta",
    PopupTextBullet2: "Tarjeta de crédito expirada",
    PopupTextBullet3: "Políticas de prevención de fraude del banco",
    PopupButton: "Actualizar detalles",
  },
});

class PaymentFailPopup extends Component {
  constructor(props) {
    super(props);

    const accessData = this.props.accessData;

    this.handlePopupClose = this.handlePopupClose.bind(this);

    this.state = {
      accessData: accessData,
    };
  }

  async componentWillMount() {
    this._isMounted = true;
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (!this._isMounted) return;
          if (snapshot.exists()) {
            let userDetails = snapshot.val();
            this.setState({
              userName: userDetails.name,
            });
          }
        });

      // Code to get latest payment failure date
      await fire
        .database()
        .ref("individualNotifications")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (!this._isMounted) return;
          let latestNotice = 0;
          //go through all with notificationType === 3
          snapshot.forEach((childSnapshot) => {
            if (childSnapshot.val().notificationType === 3) {
              if (childSnapshot.val().created > latestNotice) {
                latestNotice = childSnapshot.val().created;
              }
            }
          });

          this.setState({
            createdDate: latestNotice * 1000,
          });
        });

      // Check for paid status, if not paid, show pop-up
      await fire
        .database()
        .ref("stripeWebhookTesting")
        .child("testingPaymentStatus")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (!this._isMounted) return;
          if (snapshot.exists()) {
            if (snapshot.val().status === "paid") {
              this.setState({
                showPopup: false,
              });
            } else {
              this.setState({
                showPopup: true,
              });
            }
          } else {
            this.setState({
              showPopup: false,
            });
          }
        });
    }
  }

  async handlePopupClose() {
    // await fire
    //   .database()
    //   .ref("individualNotifications")
    //   .child(auth.currentUser.uid)
    //   .once("value")
    //   .then(snapshot => {
    //     snapshot.forEach(childSnapshot => {
    //       if(childSnapshot.val().notificationType === 3){
    //         fire
    //           .database()
    //           .ref("individualNotifications")
    //           .child(auth.currentUser.uid)
    //           .child(childSnapshot.key)
    //           .update({
    //             seenByUser: true,
    //           })
    //       }
    //     })
    //   })

    this.setState({
      showPopup: false,
    });
  }

  dateTimeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time / 1000} format="full" includeDay />;
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    if (this.state.currentLanguage === "ja") {
      return (
        <div>
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-50w"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Modal.Header closeButton style={{ border: "none" }}>
              <Modal.Title
                style={{
                  textAlign: "center",
                  color: "#FF2121",
                  fontSize: "30px",
                  marginTop: "10px",
                }}
              >
                {localizationStrings.PopupHeader}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                <strong>{this.dateTimeFormat(this.state.createdDate)}</strong>
                {localizationStrings.PopupText2_1}.
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText3}
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText4}
              </p>
              <ul
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet1}
                  </p>
                </li>
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet2}
                  </p>
                </li>
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet3}
                  </p>
                </li>
              </ul>
              <br />
              <div style={{ display: "flex", width: "90%", margin: "auto" }}>
                <NavLink
                  to="/accountManagement"
                  className="nav-link"
                  onClick={this.handlePopupClose}
                >
                  <button
                    className="boldFont"
                    style={{
                      backgroundColor: "#59A9F3",
                      color: "white",
                      border: "none",
                      height: "40px",
                      width: "200px",
                      borderRadius: "5px",
                    }}
                  >
                    <p style={{ margin: "auto", padding: "auto" }}>
                      {localizationStrings.PopupButton}
                    </p>
                  </button>
                </NavLink>
              </div>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText5}
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText6_1}
                <span style={{ color: "#369AF6", textDecoration: "underline" }}>
                  <a href="mailto: support@egeetouch.com">
                    {localizationStrings.PopupText6_2}
                  </a>
                </span>
                {localizationStrings.PopupText6_3}
              </p>
              <br />
              <br />
            </Modal.Body>
          </Modal>
        </div>
      );
    } else {
      //if language === "en"
      return (
        <div>
          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-50w"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Modal.Header closeButton style={{ border: "none" }}>
              <Modal.Title
                style={{
                  textAlign: "center",
                  color: "#FF2121",
                  fontSize: "30px",
                  marginTop: "10px",
                }}
              >
                {localizationStrings.PopupHeader}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText2}
                <strong>{this.dateTimeFormat(this.state.createdDate)}</strong>
                {this.state.currentLanguage === "en"
                  ? ""
                  : localizationStrings.PopupText2_1}
                .
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText3}
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText4}
              </p>
              <ul
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet1}
                  </p>
                </li>
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet2}
                  </p>
                </li>
                <li style={{ color: "#FF2121", fontSize: "30px" }}>
                  <p
                    className="lightFont"
                    style={{
                      color: "#3C3E41",
                      display: "table-cell",
                      verticalAlign: "middle",
                    }}
                  >
                    {localizationStrings.PopupTextBullet3}
                  </p>
                </li>
              </ul>
              <br />
              <div style={{ display: "flex", width: "90%", margin: "auto" }}>
                <NavLink
                  to="/accountManagement"
                  className="nav-link"
                  onClick={this.handlePopupClose}
                >
                  <button
                    className="boldFont"
                    style={{
                      backgroundColor: "#59A9F3",
                      color: "white",
                      border: "none",
                      height: "40px",
                      width: "200px",
                      borderRadius: "5px",
                    }}
                  >
                    <p style={{ margin: "auto", padding: "auto" }}>
                      {localizationStrings.PopupButton}
                    </p>
                  </button>
                </NavLink>
              </div>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText5}
              </p>
              <br />
              <p
                className="lightFont"
                style={{ width: "90%", textAlign: "left" }}
              >
                {localizationStrings.PopupText6_1}
                <span style={{ color: "#369AF6", textDecoration: "underline" }}>
                  <a href="mailto: support@egeetouch.com">
                    {localizationStrings.PopupText6_2}
                  </a>
                </span>
                {localizationStrings.PopupText6_3}
              </p>
              <br />
              <br />
            </Modal.Body>
          </Modal>
        </div>
      );
    }
  }
}

export default PaymentFailPopup;
